<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "FakturPajakIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
